import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-move",
  "use": "icon-move-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-move\"><path d=\"M25 20v-3h-8v8h3l-4 4-4-4h3v-8H7v3l-4-4 4-4v3h8V7h-3l4-4 4 4h-3v8h8v-3l4 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol